<template>
  <div class="tutorial-matching-list">
    <v-card class="text-center py-2 px-sm-10">
      <v-card-text>
        <div
          class="text-h5 font-weight-medium text--primary"
          style="opacity: 0.8"
        >
          Matching
        </div>
        <v-simple-table
          class="text-subtitle mt-10"
          dense
          v-if="matchings.length"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th style="width: 25%" class="text-center">Name</th>
                <th style="width: 25%" class="text-center">Start</th>
                <th style="width: 25%" class="text-center">Ende</th>
                <th style="width: 25%" class="text-center">Teilgenommen</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in matchings">
                <tr :key="index" @click="loadRouterLink(item.id)">
                  <td class="text-center">
                    {{ item.title }}
                  </td>
                  <td class="text-center">
                    {{ getFormattedDate(item.start) }}
                  </td>
                  <td class="text-center">
                    {{ getFormattedDate(item.end) }}
                  </td>

                  <td>
                    <v-checkbox
                      class="text-center"
                      :input-value="item.participated"
                      value
                      disabled
                    ></v-checkbox>
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
        <div v-else class="text-center">
          <img
            src="@/assets/Images/undraw/no_subscription.svg"
            style="max-height: 300px"
          />
          <div class="text-caption pt-3 text--secondary">
            Momentan gibt es noch keine Matchings für dich.
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
  name: "MatchingListView",
  methods: {
    loadRouterLink(id) {
      this.$router.push({ name: "tutorials.matching.id", params: { id: id } });
    },
    getFormattedDate(date) {
      if (!date) return "-";
      const d = date.split("-");
      if (d.length >= 3) {
        return d[2] + "-" + d[1] + "-" + d[0];
      } else {
        return date;
      }
    },
  },
  setup(_, { root }) {
    const matchings = ref([]);
    root.$axios.get("matching/my").then((res) => (matchings.value = res.data));

    return {
      matchings,
    };
  },
});
</script>

<style lang="css" scoped>
td {
  padding: 1rem !important;
}

.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

button {
  background-color: transparent !important;
}

.v-btn--icon.v-size--default {
  width: initial;
  height: initial;
}
</style>

<style>
.tutorial-matching-list .v-input__slot {
  text-align: right;
  display: inline;
  margin-bottom: 0;
}

.tutorial-matching-list .v-messages {
  min-height: 0;
  min-width: 0;
}

.tutorial-matching-list .v-input__control {
  display: initial;
}

.tutorial-matching-list .v-input--selection-controls__input {
  margin-right: 0 !important;
}

.tutorial-matching-list table {
  cursor: pointer;
}
</style>
